import { ProtectorType } from 'core/constants';

import { AuditQuestion } from './types';

export type QuestionShape = { questionType: ProtectorType; lookupType?: string | null };

/** What a question minted beside `source` starts as. A lookup that points at nothing would mint a second
 *  question in that same state, so that one falls back to short text. */
export const inheritQuestionShape = (source?: AuditQuestion): QuestionShape => {
  if (!source || (source.questionType === ProtectorType.Lookup && !source.lookupType)) {
    return { questionType: ProtectorType.ShortText };
  }
  return { questionType: source.questionType, lookupType: source.lookupType };
};
